import { render } from "./artsComponent.vue?vue&type=template&id=11bab8fc"
import script from "./artsComponent.vue?vue&type=script&lang=js"
export * from "./artsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__